import { useEffect, useRef } from 'react'

/**
 * useInfiniteScroll
 * Calls `onLoadMore` when the sentinel enters the viewport and `enabled` is true.
 * Returns a ref to attach to the sentinel element.
 */
export function useInfiniteScroll(onLoadMore: () => void, enabled: boolean) {
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!enabled) return
    const node = ref.current
    if (!node) return
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onLoadMore()
        }
      },
      { rootMargin: '0px 0px 200px 0px', threshold: 0 },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [onLoadMore, enabled])

  return ref
}
